import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import menu_pt from './Translations/pt/menu.json';
import menu_en from './Translations/en/menu.json';
import common_pt from './Translations/pt/common.json';
import common_en from './Translations/en/common.json';
import profile_pt from './Translations/pt/profile.json';
import profile_en from './Translations/en/profile.json';
import sidebar_pt from './Translations/pt/sidebar.json';
import sidebar_en from './Translations/en/sidebar.json';
import dashboard_pt from './Translations/pt/dashboard.json';
import dashboard_en from './Translations/en/dashboard.json';
import events_pt from './Translations/pt/events.json';
import events_en from './Translations/en/events.json';
import users_pt from './Translations/pt/users.json';
import users_en from './Translations/en/users.json';
import devices_pt from './Translations/pt/devices.json';
import devices_en from './Translations/en/devices.json';
import listings_pt from './Translations/pt/listings.json';
import listings_en from './Translations/en/listings.json';
import heatmap_pt from './Translations/pt/heatmap.json';
import heatmap_en from './Translations/en/heatmap.json';
import clients_pt from './Translations/pt/clients.json';
import clients_en from './Translations/en/clients.json';
import dwell_pt from './Translations/pt/dwell.json';
import dwell_en from './Translations/en/dwell.json';
import ingestion_pt from './Translations/pt/ingestion.json';
import ingestion_en from './Translations/en/ingestion.json';

const resources = {
  en: {
    menu: menu_en,
    common: common_en,
    profile: profile_en,
    sidebar: sidebar_en,
    dashboard: dashboard_en,
    events: events_en,
    users: users_en,
    devices: devices_en,
    listings: listings_en,
    heatmap: heatmap_en,
    clients: clients_en,
    dwell: dwell_en,
    ingestion: ingestion_en,
  },
  pt: {
    menu: menu_pt,
    common: common_pt,
    profile: profile_pt,
    sidebar: sidebar_pt,
    dashboard: dashboard_pt,
    events: events_pt,
    users: users_pt,
    devices: devices_pt,
    listings: listings_pt,
    heatmap: heatmap_pt,
    clients: clients_pt,
    dwell: dwell_pt,
    ingestion: ingestion_pt,
  },
};

const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES.split(';');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: availableLanguages.length > 1 && localStorage.getItem('preferedLanguage') ? localStorage.getItem('preferedLanguage') : availableLanguages[0],
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
